import { c as _c } from "react/compiler-runtime";
import { Camera } from 'lucide-react';
import Image from 'next/image';
import { Link } from '@/core/i18n/navigation';
import { Brand as BrandType } from '@/shared/types/blocks/common';

// Helper to render brand title with "AI" highlighted (legacy templates)
function renderBrandTitle(title: string) {
  if (title.endsWith('AI')) {
    const prefix = title.slice(0, -2);
    return <>
        {prefix}
        <span style={{
        color: '#ea873a'
      }}>AI</span>
      </>;
  }
  return title;
}
function isGetShotAI(title?: string) {
  return title === 'GetShotAI';
}
function isGetShotPassport(title?: string) {
  return title === 'GetShot Passport';
}

/**
 * GetShot Passport wordmark — a round blue "camera aperture" badge with a
 * small green verification check at its centre, followed by the two-tone
 * wordmark. Independent, non-governmental identity (no seal / monogram).
 */
function GetShotPassportWordmark() {
  const $ = _c(4);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      background: "linear-gradient(145deg, #0e56df, #1ba8e4)",
      boxShadow: "inset 0 0 0 1px rgba(255,255,255,.35)"
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <span className="absolute inset-[7px] rounded-full" style={{
      background: "conic-gradient(from -20deg, transparent 0 12%, #fff 12% 25%, transparent 25% 38%, #fff 38% 51%, transparent 51% 64%, #fff 64% 77%, transparent 77% 90%, #fff 90%)"
    }} />;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <span aria-hidden={true} className="relative grid size-9 place-items-center overflow-hidden rounded-full" style={t0}>{t1}<span className="relative grid size-[15px] place-items-center rounded-full bg-white text-[11px] font-black leading-none" style={{
        color: "#16a66a"
      }}>✓</span></span>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="flex items-center gap-2.5">{t2}<span className="text-[19px] font-semibold leading-none tracking-tight text-foreground"><span className="font-extrabold text-primary">GetShot</span> Passport</span></span>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  return t3;
}
export function BrandLogo(t0) {
  const $ = _c(19);
  const {
    brand
  } = t0;
  const t1 = brand.url || "";
  const t2 = brand.target || "_self";
  const t3 = `group flex items-center space-x-2 ${brand.className}`;
  let t4;
  if ($[0] !== brand.logo || $[1] !== brand.title) {
    t4 = isGetShotPassport(brand.title) && !brand.logo && <GetShotPassportWordmark />;
    $[0] = brand.logo;
    $[1] = brand.title;
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== brand.logo || $[4] !== brand.title) {
    t5 = isGetShotAI(brand.title) && !brand.logo && <div className="rounded-lg p-1.5 transition-transform group-hover:rotate-12" style={{
      backgroundColor: "#ea873a"
    }}><Camera className="h-5 w-5 text-white" /></div>;
    $[3] = brand.logo;
    $[4] = brand.title;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] !== brand.logo || $[7] !== brand.title) {
    t6 = brand.logo && <Image src={brand.logo.src} alt={brand.title ? "" : brand.logo.alt || ""} width={brand.logo.width || 80} height={brand.logo.height || 80} className="h-8 w-auto rounded-lg" unoptimized={brand.logo.src.startsWith("http")} />;
    $[6] = brand.logo;
    $[7] = brand.title;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  let t7;
  if ($[9] !== brand.title) {
    t7 = brand.title && !isGetShotPassport(brand.title) && <span className="text-xl font-bold tracking-tight">{renderBrandTitle(brand.title)}</span>;
    $[9] = brand.title;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5 || $[16] !== t6 || $[17] !== t7) {
    t8 = <Link href={t1} target={t2} className={t3}>{t4}{t5}{t6}{t7}</Link>;
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
    $[18] = t8;
  } else {
    t8 = $[18];
  }
  return t8;
}